import React from 'react';
function EventRow(props){
    return <React.Fragment>
        <tr id={props.id}>
            <td className='name'>{props.name}</td>
            <td className='date'>{props.date}</td>
        </tr>
    </React.Fragment>
}
export default EventRow;